import { render, staticRenderFns } from "./DeleteFavoriteItem.vue?vue&type=template&id=3a78b210&"
import script from "./DeleteFavoriteItem.vue?vue&type=script&lang=js&"
export * from "./DeleteFavoriteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports